module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view__tabs"
  }, [_c('ul', {
    staticClass: "view__tabs--menu"
  }, [_c('li', {
    class: _vm.getCssClass('group')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'group',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Label_Definition')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('group-custom-fields')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'group-custom-fields',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Label_CustomFields')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('group-payment-options')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'group-payment-options',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Label_PaymentOptions')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('import')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'import'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Settings_Import_Export_Breadcrumb')) + "\n            ")])], 1)]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "label": _vm.actions.label,
      "links": _vm.actions.links,
      "isNotSync": true,
      "acc": "actions"
    },
    on: {
      "delete": _vm.deleteGroup
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cf956c7!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/groups/Submenu.vue
// module id = 704
// module chunks = 1